import { ItineraryImage } from './../itineray.model';
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AngularFireStorage } from "@angular/fire/storage";
import { v4 as uuid } from "uuid";
import { environment } from "../../environments/environment";

@Component({
  selector: 'app-image-form-field',
  templateUrl: './image-form-field.component.html',
  styleUrls: ['./image-form-field.component.css']
})
export class ImageFormFieldComponent implements OnInit {

  @Input()
  image: ItineraryImage;

  @Output()
  imageChange = new EventEmitter<ItineraryImage>();

  @Input()
  basePath: string;

  @Input()
  label: string;

  @Input()
  disabled: boolean;

  loading = false;

  dragging = false;

  constructor(
    private sanitizer: DomSanitizer,
    private snackBar: MatSnackBar,
    private afStorage: AngularFireStorage
  ) { }

  ngOnInit() { }

  sanitizeImageUrl(url) {
    return this.sanitizer.bypassSecurityTrustStyle(url);
  }

  _getNewFilePath(fileName?) {
    console.log(this.basePath);
    return this.basePath + "/" + uuid() + "_" + (fileName || "");
  }

  _onUploadSuccess(data: firebase.storage.UploadTaskSnapshot) {
    data.ref.getDownloadURL().then(url => {
      if (this.image) { this.deleteImageFromStorage(this.image); }
      this.image = { url: url, ref: data.ref.fullPath };
      this.imageChange.emit(this.image);
      this.loading = false;
      this.dragging = false;
    }).catch(this._onError);
  }

  _onError(error) {
    console.error(error);
    alert(
      "Mi dispiace, si è verificato un errore durante il caricamento dei file."
    );
    this.loading = false;
  }

  uploadImage(event) {
    //TODO: mettere in sicurezza firebase storage permettendo solo immagini

    this.loading = true;

    for (const file of event.target.files) {
      const filePath = this._getNewFilePath(file.name);
      const task = this.afStorage.upload(filePath, file);
      task
        .then((data) => this._onUploadSuccess(data))
        .catch((error) => this._onError(error));
    }
  }

  importFromUrl() {
    const url = prompt("Inserisci qui l'indirizzo dell'immagine");
    if (!url) { return; }

    this.loading = true;

    fetch(environment.corsProxyUrl + '/' + url).then(async (response) => {
      const contentType = response.headers.get('content-type');
      const filePath = this._getNewFilePath();
      const blob = await response.blob();
      const task = this.afStorage.upload(filePath, blob, {
        contentType,
      });
      task
        .then((data) => this._onUploadSuccess(data))
        .catch((error) => this._onError(error));
    });
  }

  deleteImage($event) {
    $event.preventDefault();
    $event.stopPropagation();

    const backupImage = this.image;
    this.image = null;
    this.imageChange.emit(this.image);

    const timerId = setTimeout(() => {
      this.deleteImageFromStorage(backupImage);
    }, 5000);

    this.snackBar
      .open("Foto eliminata", "Annulla", {
        duration: 4000
      })
      .onAction()
      .subscribe(() => {
        this.image = backupImage;
        this.imageChange.emit(this.image);

        clearTimeout(timerId);
        this.snackBar.open(
          "La foto che avevi eliminato è stata ripristinata",
          null,
          {
            duration: 4000
          }
        );
      });
  }

  deleteImageFromStorage(image: ItineraryImage) {
    if (image.ref) {
      this.afStorage.ref(image.ref).delete().toPromise().catch((error) => console.error(error));
    }
  }

  onDragOver($event) {
    this.dragging = true;
  }

  onDragLeave($event) {
    this.dragging = false;
  }

}
